import FloatingText from './FloatingText';

export default FloatingText;
